import base from './base'

let controller = 'guarantee'
let action = null

const Guarantee = {
  async listGuarantees (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'id',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    if (querys.statusList !== null && querys.statusList instanceof Array && querys.statusList.length === 0) {
      querys.statusList = null
    }
    querys.isLocal = (query.isLocal !== null && query.isLocal !== undefined) ? query.isLocal ? true : false : null
    querys.showJoint = (query.showJoint !== null && query.showJoint !== undefined) ? query.showJoint ? true : false : null
    action = 'ListGuarantees'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async verifyByCode(verifyCode) {
    if (!verifyCode) {
      throw new Error('保函验真码为空')
    }
    action = `Verify/${verifyCode}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async verifyByOrderNumber (orderNumber) {
    if (!orderNumber) {
      throw new Error('保函编号为空')
    }
    action = `VerifyGuarantee/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getGuaranteeDetail (orderNumber) {
    if (!orderNumber) {
      throw new Error('OrderNumber为空')
    }
    action = `Detail/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async preAuditGuarantee (orderNumber, request) {
    action = `PreAudit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async preAuditGuaranteeNoSign (orderNumber, request) {
    action = `PreAudit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditGuarantee (orderNumber, request) {
    action = `Audit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async auditGuaranteeNoSign (orderNumber, request) {
    action = `Audit/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditTerminate (orderNumber, request) {
    action = `AuditTerminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async auditTerminateNoSign (orderNumber, request) {
    action = `AuditTerminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async terminate (orderNumber, request) {
    action = `Terminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async terminateNoSign (orderNumber, request) {
    action = `Terminate/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async checkViewPermission (orderNumber) {
    action = `CheckViewPermission/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getSupervisionPermission (orderNumber) {
    action = `GetSupervisionPermissions/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addGuarantee (request) {
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async draftGuarantee (request) {
    action = 'SaveDraft'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async addGuaranteeWithCert (request) {
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.md5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async updateGuarantee (request) {
    let tid = JSON.parse(request).id
    if (!tid) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: JSON.parse(request)
    }
    return base.request(reqModel)
  },

  async deleteGuarantee (orderNumber) {
    if (!orderNumber) {
      throw new Error('OrderNumber为空')
    }
    action = `Delete/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  /**
   * 增加保函备注
   * @param {*} orderNumber 
   * @param {*} remark 
   * @returns 
   */
  async setGuaranteeRemark (orderNumber, remark) {
    action = `SetGuaranteeRemark/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: require('qs').stringify({remark: remark})
    }
    return base.requestRaw(reqModel)
  },

  /**
   * 增加保函备注(自己可见)
   * @param {*} orderNumber 
   * @param {*} remark 
   * @returns 
   */
  async setRemark (orderNumber, remark) {
    action = `SetRemark/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: require('qs').stringify({remark: remark})
    }
    return base.requestRaw(reqModel)
  },

  async getMyRemark (orderNumber) {
    action = `GetMyRemark/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async getGuaranteeVarieties (type = "ALL") {
    action = `GetVarieties/${type}`
    let reqModel = {
      method: 'GET',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addGuaranteeVariety (request) {
    action = `AddVariety`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        name: request.name,
        fullName: request.fullName,
        coefficient: request.coefficient || 1,
        isGlobal: request.isGlobal || true,
        type: request.type || '支付类'
      }
    }
    return base.request(reqModel)
  },

  async editGuaranteeVariety (request) {
    action = `EditVariety`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        id: request.id,
        name: request.name,
        fullName: request.fullName,
        coefficient: request.coefficient || 1,
        isGlobal: request.isGlobal || true,
        type: request.type || '支付类'
      }
    }
    return base.request(reqModel)
  },

  async deleteGuaranteeVariety (id) {
    action = `DeleteVariety/${id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async checkAllowance (amount, guarantorId, cityId, industryId) {
    action = `CheckAllowance`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        amount,
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async checkMinRate (rate, guarantorId, cityId, industryId) {
    action = `CheckMinRate`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        rate,
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async getCalculatedBalance (guarantorId, cityId, industryId) {
    action = `GetCalculatedBalance`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async getUndergoingBalance (guarantorId, cityId, industryId) {
    action = `GetUndergoingBalance`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async getCumulativeBalance (guarantorId, cityId, industryId) {
    action = `GetCumulativeBalance`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async updateCalculatedBalance (guarantorId, cityId, industryId) {
    action = `UpdateCalculatedBalance`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async updateUndergoingBalance (guarantorId, cityId, industryId) {
    action = `UpdateUndergoingBalance`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async updateCumulativeBalance (guarantorId, cityId, industryId) {
    action = `UpdateCumulativeBalance`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        guarantorId,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

  async generateGuarantee (templateId, orderNumber) {
    action = `Pdf/Generate/${templateId}/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async revokePdf (orderNumber, request) {
    action = `Pdf/Revoke/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async startRemoteSign (orderNumber) {
    action = `Pdf/StartSign/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getPlainText (pdfId) {
    action = `Pdf/GetPlainText/${pdfId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async setCipherText (query) {
    action = `Pdf/SetCipherText`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        pdfId: query.pdfId,
        cipherText: query.cipherText
      }
    }
    return base.request(reqModel)
  },

  async getPdfDownloadUrl (orderNumber) {
    action = `Pdf/GetDownloadUrl/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  /**
   * 获取OSS上传参数
   * @param {*} type 1：担保合同|2：竣工手续
   */
  async getUploadParams (type) {
    if (!type) {
      throw new Error('参数错误')
    }
    action = `GetUploadParams/${type}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  /**
   * 获取OSS文件实际地址
   * @param {*} key OSSKey
   */
  async getOssUrl (key) {
    if (!key) {
      throw new Error('参数错误')
    }
    action = `GetOssUrl/${key}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async listFileRequirements (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'tid',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    action = 'ListFileRequirements'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async createFileRequirement (model) {
    action = 'CreateFileRequirement'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateFileRequirement (model) {
    if (!model || !model.id) {
      throw new Error('参数错误')
    }
    action = `UpdateFileRequirement/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async deleteFileRequirement (tid) {
    if (!tid) {
      throw new Error('参数错误')
    }
    action = `DeleteFileRequirement/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async getGuaranteeRenewals (tid) {
    if (!tid) {
      throw new Error('参数错误')
    }
    action = `GetGuaranteeRenewals/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async applyGuaranteeRenewal (request) {
    action = `ApplyGuaranteeRenewal`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async applyGuaranteeRenewalNoSign (request) {
    action = `ApplyGuaranteeRenewal`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditGuaranteeRenewal (request) {
    action = `AuditGuaranteeRenewal`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        certSn: request.certSn,
        raw: request.raw,
        md5: request.mD5,
        sign: request.sign,
        timestamp: Date.now()
      }
    }
    return base.request(reqModel)
  },

  async auditGuaranteeRenewalNoSign (request) {
    action = `AuditGuaranteeRenewal`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async listClaims (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'createTime',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    action = 'ListGuaranteeClaim'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async getClaimDetail (id) {
    action = `GuaranteeClaimDetail/${id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async addClaim (model) {
    let data = {
      guaranteeId: model.guaranteeId,
      reasonByOwner: model.reasonByOwner,
      reasonByContractor: model.reasonByContractor,
      method: model.method,
      amount: model.amount || 0,
      depositUsed: model.depositUsed || null,
      attachments: model.attachments || []
    }
    action = 'ClaimGuarantee'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: data
    }
    return base.request(reqModel)
  },

  async editClaim (model) {
    let data = {
      id: model.id,
      status: model.status || 0,
      guaranteeId: model.guaranteeId,
      reasonByOwner: model.reasonByOwner,
      reasonByContractor: model.reasonByContractor,
      method: model.method,
      amount: model.amount || 0,
      depositUsed: model.depositUsed || null,
      attachments: model.attachments || []
    }
    action = 'EditClaimGuarantee'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: data
    }
    return base.request(reqModel)
  },

  async auditClaim (model) {
    let data = {
      id: model.id,
      pass: model.pass || false,
      comment: model.comment
    }
    action = 'AuditGuaranteeClaim'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: data
    }
    return base.request(reqModel)
  },

  async listGuaranteedBadRecord (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'createTime',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    action = 'ListGuaranteedBadRecord'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addGuaranteedBadRecord(model) {
    let data = {
      GuaranteedName: model.GuaranteedName,
      GuaranteedBusinessLicense: model.GuaranteedBusinessLicense,
      ProjectName: model.ProjectName,
      PrjManagerName: model.PrjManagerName,
      PrjManagerConstructorNo: model.PrjManagerConstructorNo,
      PrjCityId: model.PrjCityId,
      GuaType: model.GuaType,
      GuaAmount: model.GuaAmount,
      CompensationDate: model.CompensationDate,
      CompensationAmount: model.CompensationAmount,
      AgreedPayDate: model.AgreedPayDate,
      AgreedPayAmount: model.AgreedPayAmount,
      IsPaidOff: model.IsPaidOff
    }
    action = 'AddGuaranteedBadRecord'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: data
    }
    return base.request(reqModel)
  },

  async editGuaranteedBadRecord (model) {
    let data = {
      Id: model.Id,
      GuaranteedName: model.GuaranteedName,
      GuaranteedBusinessLicense: model.GuaranteedBusinessLicense,
      ProjectName: model.ProjectName,
      PrjManagerName: model.PrjManagerName,
      PrjManagerConstructorNo: model.PrjManagerConstructorNo,
      PrjCityId: model.PrjCityId,
      GuaType: model.GuaType,
      GuaAmount: model.GuaAmount,
      CompensationDate: model.CompensationDate,
      CompensationAmount: model.CompensationAmount,
      AgreedPayDate: model.AgreedPayDate,
      AgreedPayAmount: model.AgreedPayAmount,
      IsPaidOff: model.IsPaidOff
    }
    action = 'EditGuaranteedBadRecord'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: data
    }
    return base.request(reqModel)
  },

  async deleteGuaranteedBadRecord (id) {
    action = `DeleteGuaranteedBadRecord/${id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async guaranteedBadRecordDetail (id) {
    action = `GuaranteedBadRecordDetail/${id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async verifyPdfFile (file, captcha) {
    action = `VerifyPdfFile`
    let data = new FormData()
    data.append('file', file)
    data.append('captcha', captcha)
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: data
    }
    return base.request(reqModel)
  },

  // 整改相关接口
  async createCorrection (request) {
    action = 'CreateCorrection'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async submitCorrection (request) {
    action = 'SubmitCorrection'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async auditCorrection (request) {
    action = 'AuditCorrection'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async getCorrections (orderNumber) {
    action = `GetCorrections/${orderNumber}`
    let reqModel = {
      method: 'GET',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },
}

export default Guarantee